import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const MutasiManasuka = (
  data = [],
  namaBulan,
  tahun,
  jenis = '1'
) => {
  namaBulan = namaBulan || "Tidak Diketahui";
  tahun = tahun || new Date().getFullYear();
  const jenisLabel = jenis === '2' ? 'Masyarakat' : 'Anggota';

  const doc = new jsPDF("p", "mm", "a4");

  const pageWidth = doc.internal.pageSize.getWidth();
  const loadImageAsDataURL = (url) => {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
};

const drawHeader = (judul, subJudul, jenisLabel, logoDataUrl) => {
  const logoX = 10;
  const logoY = 8;
  const logoSize = 18;
  const textX = logoX + logoSize + 3;

  if (logoDataUrl) {
    doc.addImage(
      logoDataUrl,
      "PNG",
      logoX,
      logoY,
      logoSize,
      logoSize
    );
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("KPRI SRI REJEKI", textX, 14);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 19);

  const lineY = logoY + logoSize + 3;

  doc.setLineWidth(0.3);
  doc.line(8, lineY, pageWidth - 8, lineY);

  const reportY = lineY + 7;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(judul, pageWidth / 2, reportY, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(subJudul, pageWidth / 2, reportY + 5, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text('Kelompok : ' + jenisLabel, pageWidth / 2, reportY + 10, {
    align: "center",
  });

  return reportY + 15;
};


  const totalSaldoAwal = data.reduce(
    (sum, item) => sum + Number(item.saldoawal || 0),
    0
  );

  const totalSetor = data.reduce(
    (sum, item) => sum + Number(item.setor || 0),
    0
  );

  const totalTarik = data.reduce(
    (sum, item) => sum + Number(item.tarik || 0),
    0
  );

  const totalTerimaJasa = data.reduce(
    (sum, item) => sum + Number(item.terimajasa || 0),
    0
  );

  const totalPajakJasa = data.reduce(
    (sum, item) => sum + Number(item.pajakjasa || 0),
    0
  );

  const totalSaldoAkhir = data.reduce(
    (sum, item) => sum + Number(item.saldoakh || 0),
    0
  );

  const body = data.map((item, index) => [
    index + 1,
    item.noanggota || "",
    item.nama || "",
    Number(item.saldoawal || 0).toLocaleString("id-ID"),
    Number(item.setor || 0).toLocaleString("id-ID"),
    Number(item.tarik || 0).toLocaleString("id-ID"),
    Number(item.terimajasa || 0).toLocaleString("id-ID"),
    Number(item.pajakjasa || 0).toLocaleString("id-ID"),
    Number(item.saldoakh || 0).toLocaleString("id-ID"),
  ]);

  body.push([
    "",
    "",
    "TOTAL",
    totalSaldoAwal.toLocaleString("id-ID"),
    totalSetor.toLocaleString("id-ID"),
    totalTarik.toLocaleString("id-ID"),
    totalTerimaJasa.toLocaleString("id-ID"),
    totalPajakJasa.toLocaleString("id-ID"),
    totalSaldoAkhir.toLocaleString("id-ID"),
  ]);

  const judul = "Laporan Mutasi Simpanan Manasuka";
  const subJudul = `${namaBulan} ${tahun}`;

 const renderTable = (startY) => {
  autoTable(doc, {
    startY,

    head: [[
      "NO",
      "NO ANGGOTA",
      "NAMA",
      "SALDO AWAL",
      "SETOR",
      "TARIK",
      "TERIMA JASA",
      "PAJAK JASA",
      "SALDO AKHIR"
    ]],

    body,

    theme: "grid",

    styles: {
      fontSize: 7,
      cellPadding: 1.5,
      overflow: "linebreak",
      valign: "middle",
    },

    headStyles: {
      fillColor: [40, 187, 165],
      textColor: 255,
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
    },

    columnStyles: {
      0: {
        cellWidth: 8,
        halign: "center",
      },
      1: {
        cellWidth: 20,
        halign: "center",
      },
      2: {
        cellWidth: 42,
      },
      3: {
        cellWidth: 22,
        halign: "right",
      },
      4: {
        cellWidth: 18,
        halign: "right",
      },
      5: {
        cellWidth: 18,
        halign: "right",
      },
      6: {
        cellWidth: 22,
        halign: "right",
      },
      7: {
        cellWidth: 22,
        halign: "right",
      },
      8: {
        cellWidth: 22,
        halign: "right",
      },
    },

    didParseCell: (hookData) => {
      if (hookData.row.index === body.length - 1) {
        hookData.cell.styles.fontStyle = "bold";
        hookData.cell.styles.fillColor = [235, 235, 235];
      }
    },

    didDrawPage: (data) => {
      doc.setFontSize(8);
      doc.text(
        `Page ${doc.internal.getNumberOfPages()}`,
        data.settings.margin.left,
        doc.internal.pageSize.height - 10
      );
    },

    margin: {
      top: 20,
      left: 8,
      right: 8,
      bottom: 15,
    },

    showHead: "everyPage",
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
};
const customLogoUrl = "/koperasihitamputih.png";

loadImageAsDataURL(customLogoUrl)
  .then((logoDataUrl) => {
    const startY = drawHeader(
      judul,
      subJudul,
      jenisLabel,
      logoDataUrl
    );

    renderTable(startY);
  })
  .catch((err) => {
    console.warn("Logo tidak ditemukan:", err);

    const startY = drawHeader(
      judul,
      subJudul,
      jenisLabel
    );

    renderTable(startY);
  });
};

export default MutasiManasuka;